// extracted by mini-css-extract-plugin
module.exports = {"path":"AnimatedBackground_path___w5Lr","background-wave":"AnimatedBackground_background-wave__0eY_U"};